// CRM 2.0 · M12-F4: calls for the verify page and the VJ Signatory scanner (backend routes/crm2Verify.js).
// Every call sends the login token; the server checks the login, the "CRM 2.0 › Verify agreements" permission and
// who may see full values.
import axios from "axios";
import { supabase } from "../supabaseClient";

const base = () => process.env.REACT_APP_PAYMENT_LINK_URL;
const auth = () => ({ Authorization: `Bearer ${supabase.auth.session()?.access_token}` });

// Returns data, or throws an Error with the server's message.
async function call(method, path, { data, params } = {}) {
  try {
    const res = await axios({ method, url: `${base()}${path}`, data, params, headers: auth() });
    return res.data.data;
  } catch (e) {
    const body = e.response?.data;
    const err = new Error(body?.message || e.message);
    err.status = e.response?.status;
    throw err;
  }
}

export const scanOnePage = ({ documentId, pageCode, token }) => call("get", "crm2/verify/scan", { params: token ? { token } : { documentId, pageCode } });
export const listMyAgreements = (tab) => call("get", "crm2/verify-agreements", { params: { tab } });
export const getMyAgreement = (copyId) => call("get", `crm2/verify-agreements/${copyId}`);
export const scanForAgreement = (copyId, text) => call("post", `crm2/verify-agreements/${copyId}/scan`, { data: { text } });
export const checkAgreementPage = (copyId, body) => call("post", `crm2/verify-agreements/${copyId}/check`, { data: body });
// Not matching: send the copy back to the Document Desk with the pages marked so far
export const sendBackAgreement = (copyId) => call("post", `crm2/verify-agreements/${copyId}/send-back`);
export const readAnyQr = (text) => call("post", "crm2/verify/read", { data: { text } });
